<template>
  <div style="height: 100%">
    <!-- <hear></hear> -->
    <div>
      <div class="Guarantee_status_box">
        <div
          style="
           
            display: flex;
            justify-content: space-between;
        
          "
        >
          <div class="shuaxinzhong" style="display: flex">
            <el-button
              @click="shuaxin"
              type="info"
              icon="el-icon-refresh-right"
              class="anniu"
            ></el-button>
            <el-select
              @change="achaisd"
              class="inputse"
              v-model="valse"
              placeholder="请选择施工单位"
            >
              <el-option
                v-for="item in options"
                :key="item.unify_social_credit_code"
                :label="item.company_name"
                :value="item"
              ></el-option>
            </el-select>
            <!-- <el-button
                class="anniu"
                type="success"
                icon="el-icon-plus"
                @click="handleAdd"
                >添加</el-button> -->
          </div>

          <div style="display: flex;  justify-content: space-around">
            <el-row
              style="display: flex;
 justify-content: flex-end;"
              class="mb8"
            >
              <el-col :span="19" class="seach">
                <el-input
                  v-model="params.keywords"
                  placeholder="请输入"
                ></el-input>
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  @click="shuaxin"
                ></el-button>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="shenflex">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            class="table xtable"
            stripe
            border
            align="center"
            v-loading="loading"
            highlight-current-row
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              prop="proid"
              label="序号"
              width="50"
            ></el-table-column>
            <el-table-column
              prop="bidding_number"
              align="center"
              label="项目编号"
              :show-overflow-tooltip="true"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="bidding_project_number"
              align="center"
              label="包号"
              :show-overflow-tooltip="true"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="bidding_project_name"
              :show-overflow-tooltip="true"
              align="center"
              label="采购项目名称"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="bidding_type"
              align="center"
              label="采购方式"
              :show-overflow-tooltip="true"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="bidder_notice_time"
              align="center"
              label="招标公告发布日期"
              :show-overflow-tooltip="true"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="review_time"
              align="center"
              label="评审日期"
              :show-overflow-tooltip="true"
              width="160"
            ></el-table-column>
            <!-- <el-table-column prop="content" align="center" label="采购需求内容" width="130"></el-table-column> -->
            <el-table-column
              prop="margin_amount"
              align="center"
              label="预算金额"
              :show-overflow-tooltip="true"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="unify_code"
              align="center"
              label="公司统一社会信用代码"
              :show-overflow-tooltip="true"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="company_name"
              align="center"
              :show-overflow-tooltip="true"
              label="公司名"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="source"
              align="center"
              label="信息来源"
              :show-overflow-tooltip="true"
              width="120"
            ></el-table-column>
            <el-table-column
              align="center"
              label="资金来源"
              :show-overflow-tooltip="true"
              width="120"
            >
              <template slot-scope="scope">{{
                scope.row.moneysource == 0
                  ? "政府资金"
                  : scope.row.moneysource == 1
                  ? "自筹资金"
                  : "其他自己资金"
              }}</template>
            </el-table-column>
            <el-table-column
              fixed="right"
              width="160"
              align="center"
              label="操作"
            >
              <template slot-scope="scope">
                <el-button @click="details(scope.row)" type="text" size="small"
                  >查看详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <el-dialog
        title="添加步骤"
        :visible.sync="opens"
        width="700px"
        append-to-body
      >
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
          <div style="display: flex; justify-content: center; margin-top: 20px">
            <div>
              <el-form-item label="操作名称">
                <el-input v-model="form.operation"></el-input>
              </el-form-item>
              <el-form-item label="审核等级">
                <el-input v-model="form.dengji"></el-input>
              </el-form-item>
            </div>
          </div>
          <div style="display: flex; justify-content: center">
            <!-- <el-button @click="buzhoulis" type="primary">确定</el-button> -->
            <el-button style="margin: 0px" type="primary">确定</el-button>
            <!-- <el-button @click="cancels">取消</el-button> -->
          </div>
        </el-form>
      </el-dialog>
      <el-dialog
        title="添加流程"
        :visible.sync="open"
        width="400px"
        append-to-body
      >
        <el-form ref="form" :model="form" label-width="80px" :rules="rules">
          <el-form-item label="流程名称">
            <el-input v-model="liuch.lc_name"></el-input>
          </el-form-item>
          <div
            style="display: flex; justify-content: center; margin-top: 20px"
          ></div>
        </el-form>
      </el-dialog>
      <div class="block">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentpage"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="limit"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { bhlist } from "@/api/system/liucheng";
// import hear from ".././../components/hear.vue";
import {
  concompany,
  bidding,
  generate,
  zhaobiao
} from "@/api/system/liucheng.js";
import axios from "axios";
export default {
  components: {
    // hear
  },
  name: "progress",
  data() {
    return {
      total: null,
      loading:true,
      currentpage: null,
      // params: {
      //   limit: 4,
      //   offset: 0,
      //   keywords: "",
      //   // user_id: sessionStorage.getItem("user_id"),
      // },
      BidingDocumentList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      opens: false,
      params: {
        page: 0,
        page_limit: 10,
        kws: ""
        // user_id: sessionStorage.getItem("id"),
      },
      total: null,
      limit: null,
      // 表单参数
      form: {
        name1: "",
        name2: "",
        name3: "",
        dept: "",
        user_id: "",
        lc_id: "",
        bm_id: "",
        bm_name: "",
        staff_id: "",
        staff_name: "",
        operation: "",
        dengji: ""
      },
      // 表单校验
      rules: {},
      options1: [], //选择部门
      options2: [], //选择职位
      btype: [],
      options3: [], //选择小组
      options4: [], //选择小组
      currentPage1: 5,
      currentPage2: 5,
      currentPage3: 5,
      currentPage4: 4,
      tableData: [],
      multipleSelection: [],
      liuch: {
        user_id: sessionStorage.getItem("id"),
        lc_name: "",
        gtype: ""
      },
      buzhl: false,
      buzhilist: [],
      valse: "",
      options: []
    };
  },
  mounted() {
    // this.getBhlist();
    this.zhifu();
    this.optionss();
  },
  methods: {
    optionss() {
      console.log("已开具gusdgagsdjas");
      // var bbc = sessionStorage.getItem("user_id");
      concompany().then(res => {
        this.options = res.data.data.rows;
        console.log(res.data.data.rows);
      });
    },
    achaisd(value) {
      console.log("选择公司", value);
      this.valse = value.company_name;
      this.params.unify_code = value.unify_social_credit_code;
      this.zhifu();
    },
    sousuo() {},
    handleUpdate(e) {
      // this.reset();
      this.opens = true;
      //   this.title = "修改员工信息";
    },
    handlesc(e) {
      console.log(e);
      var bbc = {
        djbh: e.djbh
      };
      // return
      axios({
        url: "https://api.hnzyxsbh.com/api/fapiao/get_pdf",
        method: "post", // params: '必须是一个无格式对象 query参数',
        data: {
          ...bbc
        },
        timeout: 1000,
        headers: {
          token: sessionStorage.getItem("token")
        }
      })
        .then(res => {
          console.log("发票pdf", res.data);
          if (res.data.code == 1) {
            let link = document.createElement(res.data.pdf_url);
            link.style.display = "none";
            link.style.download = "";
            link.target = "_blank";
            link.href = this.filepath;
            link.setAttribute("download", ".pdf");
            // +'.pdf' 通过不同的后缀名下载不同的文件
            //这里下载的是pdf格式的文件，拿到接口里的res也必须是pdf的文件流
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(link.href); //URL.revokeObjectURL() 静态方法用来释放一个之前通过调用 URL.createObjectURL() 创建的已经存在的 URL 对象。当你结束使用某个 URL 对象时，应该通过调用这个方法来让浏览器知道不再需要保持这个文件的引用了。
            document.body.removeChild(link);
          } else {
            this.$message.error(res.data.msg);
          }
          // this.$router.push("/BidSecurity/Bidpayment");
        })
        .catch(err => {
          console.log("失败", err.response.data);
          // this.$notify.error({
          //   message: err.response.data.msg,
          // });
        });
    },
    buzhlist(e) {
      this.buzhl = true;
    },
    zhifu() {
      var bbc = this.params;
      axios({
        url: "https://api.hnzyxsbh.com/handle/baohan/zhongbiao",
        method: "post", // params: '必须是一个无格式对象 query参数',
        data: {
          ...bbc
          //  ...cion
        },
        timeout: 1000,
        headers: {
          // token: sessionStorage.getItem("token"),
        }
      })
        .then(res => {
          console.log("发票列表", res);
          if (res.data.code == 1) {
            this.loading=false
            this.limit = res.data.data.kai;
            this.tableData = res.data.data.kai_total;
          }
          // else {
          //   this.$message.error(res.data.mag);
          // }
          // this.$router.push("/BidSecurity/Bidpayment");
        })
        .catch(err => {
          console.log("失败", err.response.data);
          // this.$notify.error({
          //   message: err.response.data.msg,
          // });
        });
    },
    shuaxin() {
      this.zhifu();
      this.loading=true
    },
    getBhlist() {
      bhlist(this.params).then(res => {
        this.BidingDocumentList = res.data.data.rows;
        this.total = res.data.data.total;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.params.page_limit = val;
      this.zhifu();
    },
    details(rows) {
      var bbc = JSON.stringify(rows);
      this.$router.push({ name: "zbxq", query: { params: bbc } });
      // this.open1 = true;
      // this.formData = rows;
    },
    handleCurrentChange(val) {
      this.params.page = parseInt(val - 1) * this.params.limit;
      this.currentpage = val;
      this.this.zhifu();
    }
  }
};
</script>

<style scoped>
.shuaxinzhong .inputse {
  /* width: 200px !important; */
  margin-left: 20px;
}
html body {
  height: 100% !important;
  /* background-color: #f5f6fa !important; */
}
.block {
  padding: 10px;
  padding-top: 5px !important;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.state_bh {
  font-size: 18px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #1890ff;
  width: 143px;
  height: 47px;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  line-height: 47px;
  text-align: center;
  border: 2px solid #1890ff;
}
.shenflex {
  display: flex;
  flex-direction: column;
  align-items: center;

  padding-top: 10px;
}
.status_bg1 {
  width: 85px;
  height: 40px;
  background-color: #ff1818;
  border-bottom-left-radius: 10px;
  position: relative;
  bottom: 87%;
  left: 94%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 18px;
}

.status_bg {
  width: 85px;
  height: 40px;
  background-color: #1795ff;
  border-bottom-left-radius: 10px;
  position: relative;
  bottom: 87%;
  left: 94%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 18px;
}

.examine_btn {
  width: 143px;
  height: 47px;
  color: #1795ff;
}

.bubble {
  color: #ffffff;
  font-size: 12px;
  width: 94px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 31px;
  margin-left: 20px;
  background-image: url("../../assets/Guarantee/Bubble.png");
}

.Guarantee_details {
  justify-content: space-around;
}

.Ge_box {
  width: 113px;
  height: 33px;
  border-radius: 4px;
  background-color: #1795ff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  margin-left: 15px;
}

.Guarantee_num {
  width: 219px;
  height: 48px;
  color: #333333;
}

.Guarantee_status_box {
  /* position: relative;
  top: 9%;
  left: 247px; */
}

.Guarantee_status {
  width: 95%;
  height: 162px;
  margin-bottom: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.16);
}

.Guarantee_examine {
  color: #333333;
  font-size: 24px;
  margin-left: 30px;
  margin-top: 10px;
  font-weight: Bold;
  margin-bottom: 36px;
}

::v-deep .el-table__body-wrapper {
  height: 69vh !important;
  /* margin-top: 10px; */
  overflow: auto !important;
}
</style>
<style scoped></style>



// WEBPACK FOOTER //
// src/view/biao/zhongs.vue